import React from "react";
import Styles from './styles.module.sass';
import { NavLink } from "react-router-dom";
import { SUB_DIRECTORY } from "constants/general";
import { removeStorage } from "newFunctions/storageBase64";

const ModuleCardMenu = () => {
    const dataSection = [
        {
            title: 'Saldo',
            url: `/${SUB_DIRECTORY}consultar-saldo`,
            iconClass: 'currency',
            status: true
        },
        {
            title: 'Pagar tarjeta',
            url: `/${SUB_DIRECTORY}pagar-tarjeta`,
            iconClass: 'payCard',
            status: true
        },
        {
            title: 'Movimientos',
            url: `/${SUB_DIRECTORY}movimientos-tarjeta`,
            iconClass: 'movements',
            status: true
        },
        {
            title: 'Estado de cuenta',
            url: `/${SUB_DIRECTORY}solicitar-estado-cuenta`,
            iconClass: 'filesAcounts',
            status: true
        },
        {
            title: 'Puntos',
            url: `/${SUB_DIRECTORY}puntos`,
            iconClass: 'points',
            status: false
        },
        {
            title: 'Monedero',
            url: `/${SUB_DIRECTORY}monedero`,
            iconClass: 'wallet',
            status: false
        },
        {
            title: 'NIP',
            url: `/${SUB_DIRECTORY}nip`,
            iconClass: 'nip',
            status: false
        },
        {
            title: 'Tarjeta virtual',
            url: `/${SUB_DIRECTORY}tarjeta-virtual`,
            iconClass: 'virtualCard',
            status: false
        },
        {
            title: 'Seguros',
            url: `/${SUB_DIRECTORY}seguros`,
            iconClass: 'safeCards',
            status: false
        },
        {
            title: 'Plan de pagos',
            url: `/${SUB_DIRECTORY}plan-pagos`,
            iconClass: 'calendar',
            status: false
        }
    ]

     const handleTarjetaCredito = () => {
        removeStorage('pagoExpress')
    };

    return (
        <div className={Styles?.cardMenuContent}>
            {dataSection?.length > 0
                ? dataSection?.map((item, index) => (
                    item?.status
                        ?
                            <NavLink 
                                key={index}
                                to={item?.url}
                                className={`${Styles?.cardMenuItem} ${Styles?.[item?.iconClass]}`}
                                activeClassName={`${Styles?.cardMenuItem} ${Styles?.[item?.iconClass]}  ${Styles?.active}`}
                                // exact
                                onClick={handleTarjetaCredito}
                            >{item.title}</NavLink>
                        : null
                ))
                : null 
            }
        </div>
    );
}

export default ModuleCardMenu